import React, { useCallback, useState } from 'react';

import { useIntl } from 'react-intl-next';

import type { DocNode } from '@atlaskit/adf-schema';
import Button from '@atlaskit/button/new';
import { aiSuggestionsMessages } from '@atlaskit/editor-common/ai-messages';
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../../aiSuggestionsPluginType';

import { StagingAreaModal } from './StagingArea';

export const SuggestionsToolbarButton = ({
	api,
	providerFactory,
}: {
	api?: ExtractInjectionAPI<AiSuggestionsPlugin>;
	providerFactory: ProviderFactory;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [adf, setAdf] = useState<DocNode | null>(null);

	const handleButtonClick = useCallback(() => {
		if (!isModalOpen) {
			api?.core?.actions.requestDocument((doc) => {
				setAdf(doc as DocNode);
				setIsModalOpen(true);
			});
		}
	}, [api, isModalOpen]);

	const handleCloseModal = useCallback(() => {
		setIsModalOpen(false);
	}, []);

	return (
		<>
			<Button appearance="subtle" onClick={handleButtonClick}>
				{formatMessage(aiSuggestionsMessages.suggestionsToolbarButtonLabel)}
			</Button>
			{isModalOpen && adf && (
				<StagingAreaModal
					api={api}
					adf={adf}
					onClose={handleCloseModal}
					providerFactory={providerFactory}
				/>
			)}
		</>
	);
};
